import React, { PureComponent, PropTypes } from 'react';

class TableRow extends PureComponent {
    constructor(props, ...args) {
        super(props, ...args);
        this.state = {};
    }

    static propTypes = {
        className: PropTypes.string,
        values: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
    }
    static defaultProps = {
        className: 'row'
    }

    render() {
        let { className, values } = this.props;

        let cells = values.map((value, columnIndex) => <div key={ columnIndex } >{value || '\u00a0' }</div>);

        return (<div className={ className }>
            { cells }
        </div>);
    }
}


export default TableRow;


// WEBPACK FOOTER //
// ./src/components/importer/tablerow.js